import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'filterByDay'
})
export class FilterByDayPipe implements PipeTransform {

  transform(datetimes: Date[], day: number): Date[] {
    if (datetimes) {
      console.log(day)
      return datetimes.filter((date: Date) => date.getDay() === day)
    }

    return null
  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/shared/filter-by-day/filter-by-day.pipe.ts